import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
Vue.use(Vuex)
const vxStore = new Vuex.Store({
  state: {
    Authorization: '',
    isLogin: false,
    currentUser: null
  },
  getters,
  actions,
  mutations
})

export default vxStore



// WEBPACK FOOTER //
// ./src/vuex/vxStore.js